import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionBuyTrialAPICall extends APICallV3Post {
    _method = 'billing/subscription/trial';
}
